<div class="pt-3">
    <div class="section-container">
        <div class="section-title">
            <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
            <span>Natureza da Operação</span>
            <span class="status-badge badge-cinza">{{ naturezaIds.length }} selecionada(s)</span>
        </div>

        <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
            <div class="row search-area">
                <div class="col-12 col-lg-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Pesquisar</mat-label>
                        <input matInput type="text" formControlName="pesquisa" placeholder="Descrição, CFOP...">
                        <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
        </form>

        @if (isLoading && dataSource.data.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else if (dataSource.data.length > 0) {
        <table mat-table class="desktop-view" [dataSource]="dataSource">
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="toggleAllVisible()" [checked]="isAllVisibleSelected()"></mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox">
                    <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="toggleRow(row)"
                        [checked]="isSelecionada(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef>Nome</th>
                <td mat-cell *matCellDef="let row">
                    <span>{{ row.nome }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="cfop">
                <th mat-header-cell *matHeaderCellDef>CFOP</th>
                <td mat-cell *matCellDef="let row">
                    <span class="status-badge badge-cinza">{{ row.cfopPadrao | mask: '0.000' : { patterns: cfopMaskPatterns } }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="tipo">
                <th mat-header-cell *matHeaderCellDef>Tipo</th>
                <td mat-cell *matCellDef="let row">
                    <span class="status-badge"
                        [class.badge-azul]="row.idTipoOperacao === TipoOperacaoEnum.Entrada"
                        [class.badge-laranja]="row.idTipoOperacao === TipoOperacaoEnum.Saida">
                        {{ tipoLabel[row.idTipoOperacao] || row.idTipoOperacao }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="padrao">
                <th mat-header-cell *matHeaderCellDef>Padrão</th>
                <td mat-cell *matCellDef="let row">
                    @for (tipo of row.tiposPadrao; track tipo) {
                    <span class="status-badge badge-amarelo me-1">{{ nomeTipoPadrao(tipo) }}</span>
                    } @empty {
                    <span class="text-secondary" style="font-size:0.82rem;">-</span>
                    }
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="mobile-view">
            @for (item of dataSource.data; track item.idNaturezaOperacao) {
            <div class="card-mobile mb-3" [class.selected-card]="isSelecionada(item)">
                <div class="card-header-mobile d-flex align-items-center gap-2">
                    <mat-checkbox (change)="toggleRow(item)" [checked]="isSelecionada(item)"></mat-checkbox>
                    <span class="text-bold">{{ item.nome }}</span>
                </div>
                <div class="card-body-mobile p-3">
                    <p class="mb-1"><strong>CFOP:</strong> <span class="status-badge badge-cinza ms-1">{{ item.cfopPadrao | mask: '0.000' : { patterns: cfopMaskPatterns } }}</span></p>
                    <p class="mb-1">
                        <strong>Tipo:</strong>
                        <span class="status-badge ms-1"
                            [class.badge-azul]="item.idTipoOperacao === TipoOperacaoEnum.Entrada"
                            [class.badge-laranja]="item.idTipoOperacao === TipoOperacaoEnum.Saida">
                            {{ tipoLabel[item.idTipoOperacao] || item.idTipoOperacao }}
                        </span>
                    </p>
                    <p class="mb-0">
                        <strong>Padrão:</strong>
                        @for (tipo of item.tiposPadrao; track tipo) {
                        <span class="status-badge badge-amarelo ms-1">{{ nomeTipoPadrao(tipo) }}</span>
                        } @empty {
                        <span class="text-secondary ms-1" style="font-size:0.82rem;">-</span>
                        }
                    </p>
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center mt-4 mb-2">
            <button mat-button class="btn-ver-mais btn-spinner" [class.btn-loading]="isLoading"
                [disabled]="isLoading || allData.length >= totalRegistros"
                [attr.aria-label]="isLoading ? 'Carregando mais registros' : 'Ver mais'"
                (click)="proximaPagina()">
                <span class="material-symbols-outlined">expand_more</span>
                Ver Mais
                @if (isLoading) { <mat-spinner diameter="20"></mat-spinner> }
            </button>
        </div>
        } @else {
        <app-empty-state
            icon="search_off"
            title="Nenhuma natureza de operação encontrada"
            subtitle="Ajuste a pesquisa para encontrar a natureza de operação desejada.">
        </app-empty-state>
        }
    </div>
</div>
